export default __webpack_public_path__ + "static/media/Style 7.aa0fa746.svg";